/**
 * Test IDs for QA automation.
 */
export const testIds = {
  rateFormBillingMethodSelector: "rate-form-billing-method-selector",
  rateFormBillingMethodOption: "rate-form-billing-method-option",
  rateFormAmount: "rate-form-amount",
  rateFormChargeLabel: "rate-form-charge-label",
  rateFormReference: "rate-form-reference",
  rateFormTaxable: "rate-form-taxable",
} as const;
